import { useCallback, useState, useEffect, useRef } from "react";

const useDoor = (initialState: boolean) => {
  const [open, setOpen] = useState<boolean>(initialState);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const onOpen = useCallback(() => isMounted.current && setOpen(true), [setOpen]);
  const onClose = useCallback(() => isMounted.current && setOpen(false), [setOpen]);

  const onToggle = useCallback(() => isMounted.current && setOpen(value => !value), [setOpen]);

  return { open, onOpen, onClose, onToggle };
};

export default useDoor;
